class Feat {
  constructor () {
    this.name = '';
    this.content = '';
    this.key = '';
  }
}

export default Feat;